module.exports = __webpack_public_path__ + "static/media/front.8a5ae6cf.jpg";